type BootstrapAlertLevel = 'success' | 'info' | 'warning' | 'danger';

function showMessage (message: string, level: BootstrapAlertLevel, timeout: number = NOTIFICATION_TIMER) {
  let $messageContainer = $('#messages');
  let $messageElement = $('<li class="list-group-item message"><p class="message-text"></p></li>');
  let $dismissButton = $('<button type="button" class="message-dismiss p-0 bg-transparent border-0">' +
                           '<i class="fa fa-close"></i>' +
                         '</button>');

  $messageElement.addClass(`message-${level}`);
  $messageElement.find('.message-text').text(message);
  $messageElement.append($dismissButton);
  $dismissButton.click(() => {
    $messageElement.addClass('closed');
  });

  $messageContainer.html('').append($messageElement).addClass('open');

  setTimeout(() => {
    $messageContainer.removeClass('open');
  }, timeout);
}

export default showMessage;
